import * as offer from "./offer";
import { getUrlParam } from "../pages/util/common";
import "@ali/lib-mtop";
import { Keyword } from "@alife/next/lib/breadcrumb";
window.lib.mtop.config.prefix = "h5api";
//window.lib.mtop.config.subDomain = getUrlParam("debugMode") == 1 ? "wapa" : "m";
window.lib.mtop.config.mainDomain = "1688.com";

if (window.location.href.includes("pre-p4psearch.1688.com")) {
  window.lib.mtop.config.subDomain = "wapa";
}

export const mtop = (api, data, ...options) => {
  return window.lib.mtop.request(
    {
      api, // 必须
      v: "1.0", // 必须
      data,
      ecode: 0, // 必须（注意2）
      type: "GET", // 非必须。请求类型（GET/POST），默认是GET
      dataType: "jsonp", // 非必须。数据类型（jsonp/originaljsonp/json），默认jsonp
      timeout: 20000, // 非必须。接口超时设置，默认为20000ms
      ...options,
    },
    (res) => {
      window &&
        window.goldlog.record(
          "/ifission.ifission.autoWW",
          "CLK",
          `code=${res.data ? res.data.code : ""}&msg=${
            res.data ? res.data.msg : ""
          }`,
          "GET"
        );
    }
  );
};

export const sendWW = (eurl, itemId, bizId) => {
  mtop("mtop.hamlet.engine.gateway", {
    apiEngineType: "2",
    api: "cplEnquiry",
    params: JSON.stringify({
      sk: "d816e70d380f8694a49f2d4aa2aae51d",
      ak: "mtop",
      paramMap: {
        bizId,
        pushChannelType: "WANG_WANG",
        pushTriggerType: "MANUAL",
        items: [
          {
            eurl,
            itemType: "AD",
            itemId,
          },
        ],
        cosite: getUrlParam("cosite"),
        ptid: getUrlParam("ptid"),
      },
    }),
  });
};

export const cplRecallRank = async (offerId, rankName, ptid, cosite) => {
  let data = null;
  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      data: {
        apiEngineType: "2",
        api: "cplRecall",
        params: JSON.stringify({
          sk: "d816e70d380f8694a49f2d4aa2aae51d",
          ak: "mtop",
          paramMap: {
            bizId: "lp_pc_rank",
            offerId,
            count: "8",
            offset: "0",
            rankName,
            ptid,
            cosite,
          },
        }),
      },
    },
    (res) => {
      data = res.data;
    }
  );
  return data;
};

export const cplEnquiry = async ({
  offerId,
  mobilePhone,
  nlq,
  pushChannelType,
  items,
  bizId,
  tags,
  keyword
}) => {
  //window.lib.mtop.config.subDomain = "wapa";

  let data = [];
  let paramMap = {
    bizId: bizId,
    pushTriggerType: "MANUAL",
    authorized: true,
    pushChannelType,
    items,
    offerId,
    nlq,
    cosite: getUrlParam("cosite"),
    ptid: p4pObject.ptid,
  }

  if(!!tags) {
    paramMap.tags = tags;
  }

  if(!!keyword) {
    paramMap.keyword = keyword;
  }

  if(!!mobilePhone) {
    paramMap.mobilePhone = mobilePhone;
  }

  if(!!offerId) {
    paramMap.offerId = offerId;
  }

  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      type: "POST",
      data: {
        apiEngineType: "2",
        api: "cplEnquiry",
        params: JSON.stringify({
          sk: "d816e70d380f8694a49f2d4aa2aae51d",
          ak: "mtop",
          paramMap,
        }),
      },
    },
    (res) => {
      data = res.data;
    }
  );
  return data;
};

export const cplRepo = async (params) => {
  window.lib.mtop.config.subDomain = window.location.href.includes("pre-p4psearch.1688.com") ? "wapa" : "m";

  let data = null;
  const staticParams = {
    bizId: 'lp_pcauth',
    authorized: true,
    authType: 1,
    authEnable: 1,
    cosite: window.p4pObject.cosite,
    ptid: window.p4pObject.ptid,
    predictMobilePhoneOnLogin: true
  }

  const reqParams = Object.assign(params, staticParams);
  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      type: "POST",
      data: {
        apiEngineType: "2",
        api: "cplRepo",
        params: JSON.stringify({
          sk: "d816e70d380f8694a49f2d4aa2aae51d",
          ak: "mtop",
          paramMap: reqParams
        }),
      },
    },
    (res) => {
      data = res.data;
    }
  );
  return data;
}

export const getAIData = async () => {
  window.lib.mtop.config.subDomain = window.location.href.includes("pre-p4psearch.1688.com") ? "wapa" : "m";
  let data = null;
  let paramMap = {
    keyword: getUrlParam("keywords"),
    ptid: getUrlParam("ptid"),
    bizId: 'lp_pcasst'
  }

  if(!!getUrlParam("cosite")) {
    paramMap.cosite = getUrlParam("cosite");
  }

  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      data: {
        apiEngineType: "2",
        api: "searchAssistant",
        params: JSON.stringify({
          sk: "d816e70d380f8694a49f2d4aa2aae51d",
          ak: "mtop",
          timeoutMillis: 12000,
          paramMap: paramMap
        }),
      },
    },
    (res) => {
      data = res.data && res.data.data;
    }
  );
  return data;
};

export const reloadSummary = async(tags) => {
  //window.lib.mtop.config.subDomain = "wapa";

  let data = null;
  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      data: {
        apiEngineType: "2",
        api: "summarizeIntent",
        params: JSON.stringify({
          sk: "d816e70d380f8694a49f2d4aa2aae51d",
          ak: "mtop",
          paramMap: {
            tags
          }
        }),
      },
    },
    (res) => {
      data = res.data && res.data.data;
    }
  );
  return data;
}

export const getLogin = async () => {
  let data = null;
  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      type: "POST",
      data: {
        apiEngineType: "2",
        api: "isLogin",
        params: JSON.stringify({
          sk: "d816e70d380f8694a49f2d4aa2aae51d",
          ak: "mtop",
        }),
      },
    },
    (res) => {
      data = res.data && res.data.data;
    }
  );
  return data;
};

export const queryMobilePhone = async () => {
  let queryPhone = "";
  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      data: {
        apiEngineType: 2,
        api: "querySecureMobilePhone",
        params: JSON.stringify({
          sk: "d816e70d380f8694a49f2d4aa2aae51d", // --固定值
          ak: "mtop", //--固定值
        }),
      },
    },
    (res) => {
      queryPhone = res.data ? res.data.data : null;
    }
  );
  return queryPhone;
};

export const sendSmsCode = async (mobilePhone = "") => {
  let code = "";
  let paramMap = {};

  if(mobilePhone && mobilePhone.length > 0) {
    paramMap.mobilePhone = mobilePhone;
  }

  const parmas = {
    sk: "d816e70d380f8694a49f2d4aa2aae51d", // --固定值
    ak: "mtop", //--固定值
    paramMap,
  };

  await window.lib.mtop.request(
    {
      api: "mtop.hamlet.engine.gateway",
      v: "1.0",
      type: "post",
      data: {
        apiEngineType: 2,
        api: "sendSmsCode",
        params: JSON.stringify(parmas),
      },
    },
    (res) => {
      const { data } = res;
      code = data.code;
    }
  );
  return code;
};

export default {
  ...offer,
};
